import { useCallback, useMemo } from 'react';
import { GridApi } from 'ag-grid-community';
import { updateAccountPromiseCreator } from 'actions/accountsActions';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { getUserHasAnyRole } from 'reducers/usersReducer';
import { BALANCES_READ_ONLY_ROLES } from './Balances/useBalancesColDefs';

type UpdateAccountCallback = (
  api: GridApi,
  args: { accountId: string; update: Record<string, string> },
) => Promise<void>;

const useContext = () => {
  const dispatch = useAppDispatch();
  const updateAccount: UpdateAccountCallback = useCallback(
    async (
      api: GridApi,
      {
        accountId,
        update,
      }: { accountId: string; update: Record<string, string> },
    ) => {
      await updateAccountPromiseCreator({ accountId, update }, dispatch);
      api.refreshServerSide({ purge: true });
    },
    [dispatch],
  );

  const isReadOnlyRole = useAppSelector((state) =>
    getUserHasAnyRole(state, BALANCES_READ_ONLY_ROLES),
  );
  const context = useMemo(
    () => ({ updateAccount, isReadOnlyRole }),
    [updateAccount, isReadOnlyRole],
  );

  return context;
};
export default useContext;
